import axios, { AxiosInstance, AxiosResponse } from "axios";
import router from "@/router";
import { getToken, removeToken } from "./auth";
import { message } from "./message";
import store from "@/store";
// 白名单路径
const whiteList: string[] = [
  "/index/User/login",
  "/index/User/register",
  "/index/Api/uploadImg",
  "/mobile/order/getBiInfo",
  "/index/Api/klines",
];

// 创建axios实例
const request: AxiosInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? `${window.location.protocol}//api.${window.location.host}`
      : "https://api.madgain.shop", // API的base_url
  timeout: 10000, // 请求超时时间
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
request.interceptors.request.use(
  (config: any) => {
    // 获取token
    const token = getToken();

    // 判断请求路径是否在白名单中
    const isWhiteList = whiteList.some((white) => config.url?.includes(white));

    // 如果不在白名单中且没有token，重定向到登录页
    if (!isWhiteList && !token) {
      router.push("/login");
      store.dispatch("clearLoginData");
      return Promise.reject(new Error("Please sign in."));
    }

    // 如果有token，添加到请求头
    if (token) {
      config.headers = {
        ...config.headers,
        token: token,
      };
    }

    return config;
  },
  (error) => {
    message.error(error.message || "Request error.");
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    const { data } = response;
    console.log("data", data);
    // 这里可以根据后端的响应结构进行自定义处理
    if (data.code === 0) {
      return data;
    }
    if (data.code === 100) {
      router.push("/login");
      store.dispatch("clearLoginData");
    }
    message.error(data.msg || data.message || "Request error.");
    return Promise.reject(new Error(data.msg || data.message || "Request error."));
  },
  (error) => {
    // 处理token过期
    if (error.response?.status === 401) {
      removeToken();
      message.error("Session expired. Please sign in again.");
      router.push("/login");
      store.dispatch("clearLoginData");
      return Promise.reject(error);
    }

    message.error(error.message || "Request error.");
    return Promise.reject(error);
  }
);

export default request;
